import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const SendInvitePage = lazy(() => import('./SendInvitePage'));

const SendInvitesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.UserManagement,
  routes: [
    {
      path: 'users/send-invite',
      element: <SendInvitePage />,
    },
  ],
};

export default SendInvitesConfig;
